import { render, staticRenderFns } from "./DataFilterOption.vue?vue&type=template&id=f2234e28&"
import script from "./DataFilterOption.vue?vue&type=script&lang=js&"
export * from "./DataFilterOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports